import Form from "react-bootstrap/Form";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import StatusFilter from "../StatusFilter";
import PriorityFilter from "../PriorityFilter";
import CategoryFilter from "../CategoryFilter";
import SubCategoryFilter from "../SubCategoryFilter";
import { useEffect } from "react";
import CreatedBy from "../CreatedBy";
import AssignTo from "../AssignTo";
import * as XLSX from "xlsx";
import Offcanvas from "react-bootstrap/Offcanvas";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";

function OffCanvas({ name, ...props }) {
  const [selectedAssign, setSelectedAssignTo] = useState(null);
  const [selectedCreatedBy, setSelectedCreatedBy] = useState(null);
  const [slaCheck, setSlaCheck] = useState(false);

  let statusValue;
  let categoryValue;
  let subCategoryValue;
  let priorityValue;
  let createdByValue;
  let assignToValue;



  const handleStatsClick = () => {
    if (props.selectedStatus && props.selectedStatus?.length !== 0) {
      let statusData = props.selectedStatus
        .reduce((pre, curr) => {
          pre += curr.value + "%2C";
          return pre;
        }, "")
        .slice(0, -3);
      statusValue = "&status_code=" + statusData;
    } else {
      statusValue = "";
    }

    if (props.selectedCategory && props.selectedCategory?.length !== 0) {
      let categoryData = props.selectedCategory
        .reduce((pre, curr) => {
          pre += curr?.key + "%2C";
          return pre;
        }, "")
        .slice(0, -3);
      categoryValue = "&category=" + categoryData;
    } else {
      categoryValue = "";
    }

    if (props.selectedSubCategory && props.selectedSubCategory.length !== 0) {
      let subCategoryData = props.selectedSubCategory
        .reduce((pre, curr) => {
          pre += curr.key + "%2C";
          return pre;
        }, "")
        .slice(0, -3);
      subCategoryValue = "&sub_category=" + subCategoryData;
    } else {
      subCategoryValue = "";
    }

    if (props.selectedPriority && props.selectedPriority.length !== 0) {
      let priorityData = props.selectedPriority
        ?.reduce((pre, curr) => {
          pre += curr.value + "%2C";
          return pre;
        }, "")
        .slice(0, -3);
      priorityValue = "&priority=" + priorityData;
    } else {
      priorityValue = "";
    }
    if (selectedCreatedBy && selectedCreatedBy.length !== 0) {
      let selectData = selectedCreatedBy
        ?.reduce((pre, curr) => {
          pre += curr.value + "%2C";
          return pre;
        }, "")
        .slice(0, -3);
      createdByValue = "&created_by=" + selectData;
    } else {
      createdByValue = "";
    }
    if (selectedAssign && selectedAssign.length !== 0) {
      let assignData = selectedAssign
        ?.reduce((pre, curr) => {
          pre += curr.value + "%2C";
          return pre;
        }, "")
        .slice(0, -3);
      assignToValue = "&assign_to=" + assignData;
    } else {
      assignToValue = "";
    }

    if (slaCheck) {
     const slaValue = "&slaCrossed=" + slaCheck;
      props.setStatsQueryParams(
        statusValue +
          slaValue +
          priorityValue +
          categoryValue +
          subCategoryValue +
          assignToValue +
          createdByValue
      );
    } else {
      props.setStatsQueryParams(
        statusValue +
          priorityValue +
          categoryValue +
          subCategoryValue +
          assignToValue +
          createdByValue
      );
    }
    handleClose();
  };



  const handleChange = (event) => {
    setSlaCheck(event.target.checked);
  };

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);



  return (
    <>
      <Button variant="primary" onClick={handleShow} className="me-2">
        <OverlayTrigger
          overlay={
            <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
              <div className="fs-1">more filter options</div>
            </Tooltip>
          }
        >
          <span>+ more</span>
        </OverlayTrigger>
      </Button>
      <Offcanvas show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h1>Traya</h1>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <h3 className="mt-n3">Filter Data</h3>
          <div className="d-flex flex-column gap-1">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                defaultValue=""
                id="flexCheckIndeterminate"
                onChange={handleChange}
              />
              <label
                className="form-check-label"
                htmlFor="flexCheckIndeterminate"
              >
                SLA Crossed
              </label>
            </div>
            <StatusFilter
              selectedStatus={props.selectedStatus}
              setSelectedStatus={props.setSelectedStatus}
            />
            <CategoryFilter
              selectedCategory={props.selectedCategory}
              setSelectedCategory={props.setSelectedCategory}
            />
            <SubCategoryFilter
			  selectCategory = {props?.selectedCategory}
              selectedSubCategory={props.selectedSubCategory}
              setSelectedSubCategory={props.setSelectedSubCategory}
            />
            <PriorityFilter
              selectedPriority={props.selectedPriority}
              setSelectedPriority={props.setSelectedPriority}
            />
            <AssignTo
              selectedAssign={selectedAssign}
              setSelectedAssign={setSelectedAssignTo}
            />
            <CreatedBy
              selectedCreatedBy={selectedCreatedBy}
              setSelectedCreatedBy={setSelectedCreatedBy}
            />
            <Button
              variant="primary"
              className="mt-3 mb-5"
              onClick={handleStatsClick}
            >
              Filter by Stats
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

function StatsDateFilter({
  setStatsQueryParams,
  selectedCategory,
  selectedSubCategory,
  selectedPriority,
  selectedStatus,
  setSelectedCategory,
  setSelectedSubCategory,
  setSelectedPriority,
  setSelectedStatus,
  downloadData,
}) {
  return (
    <>
      <OffCanvas
        key={6}
        placement={"end"}
        name={"Filter & Download"}
        setStatsQueryParams={setStatsQueryParams}
        selectedCategory={selectedCategory}
        selectedSubCategory={selectedSubCategory}
        selectedPriority={selectedPriority}
        selectedStatus={selectedStatus}
        setSelectedCategory={setSelectedCategory}
        setSelectedSubCategory={setSelectedSubCategory}
        setSelectedPriority={setSelectedPriority}
        setSelectedStatus={setSelectedStatus}
        downloadData={downloadData}
      />
    </>
  );
}

export default StatsDateFilter;
